
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myChannel",
      function () {
        return require("private-next-pages/myChannel.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myChannel"])
      });
    }
  